export enum ErrorType {
  ApiError = 'ApiError',
  BadSelection = 'BadSelection',
  CreditCardError = 'CreditCardError',
  Error = 'Error',
  FatalError = 'FatalError',
  InvalidCountry = 'InvalidCountry',
  NoStoresAvailable = 'NoStoresAvailable',
  RemoteTechDeviceIneligible = 'RemoteTechDeviceIneligible',
  RemoteTechLocationIneligible = 'RemoteTechLocationIneligible',
  SlotIsTakenError = 'SlotIsTakenError',
}
